export default "__VITE_ASSET__7d209169__"